/**
 * @file Helper class for dynamically inject fieldsets in a form.
 * @author Tom Verschoore de la Houssaije
 */
/**
 * The provider for a specific fieldset class.
 * Containing configuration information.
 * This provider is injected, dynamically, by a @see FieldsetContainerComponent instance,
 * and not by the angular framework.
 */
var FieldsetProvider = /** @class */ (function () {
    /**
     * Constructs a FieldsetProvider
     */
    function FieldsetProvider(container) {
        this.container = container;
        /** Gets sets the field configuration of the fieldset. */
        this.field = undefined;
        /**
         * Gets or sets the name of the block.
         * Blocks are modules of functionality.
         * The block name is used to find block specific label translations.
         */
        this.block = undefined;
        /** Path to the value property, thus excluding the value property  */
        this.path = [];
        /** The name of the value property. The value property was the last item in the path. */
        this.valueProperty = '';
        this.field = this.container.field;
        this.path = this.field.name.split('.');
        this.valueProperty = this.path.pop();
    }
    Object.defineProperty(FieldsetProvider.prototype, "control", {
        /**
         * Gets the control of the fieldset.
         * The control is used to monitor and validate field values depicted in a form.
         */
        get: function () {
            if (this.container === undefined) {
                return null;
            }
            return this.container.control;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FieldsetProvider.prototype, "entity", {
        /**
         * Gets the entity instance shown by this fieldset container.
         * Its the entity in the path that holds the value property.
         */
        get: function () {
            if (this.container === undefined) {
                return null;
            }
            // The entity in the path that holds the value property.
            var valueEntity = this.container.entity;
            if (this.path.length === 0 || !valueEntity) {
                return valueEntity;
            }
            this.path.find(function (segment) {
                valueEntity = valueEntity[segment];
                return !valueEntity;
            });
            return valueEntity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FieldsetProvider.prototype, "value", {
        /** Gets the depicted field value. */
        get: function () {
            // The entity in the path that holds the value property.
            if (this.entity == null) {
                return null;
            }
            return this.valueProperty === '@this' ? this.entity : this.entity[this.valueProperty];
        },
        /** Sets the depicted field value. */
        set: function (val) {
            var entity = this.entity;
            var property = this.valueProperty;
            if (this.entity == null) {
                var ent = this.container.entity;
                if (!ent || !ent.entityAspect.entityState.isAdded() || this.path.length === 0 || this.field.name === '@this') {
                    return;
                }
                entity = ent;
                property = '$' + this.field.name;
            }
            // When the fieldset is referring to the entity itself, it should not be (re)set.
            if (property === '@this') {
                return;
            }
            entity[property] = val;
        },
        enumerable: true,
        configurable: true
    });
    return FieldsetProvider;
}());
export { FieldsetProvider };
